import React from 'react';
var css = {
  "spinnerContainer": "rui-oVdGq",
  "rotate": "rui-Qhggd",
  "path": "rui-rFU6G",
  "dash": "rui-hzuHl"
};
import classNames from 'classnames';
var Loader = function Loader(_ref) {
  var _ref$stroke = _ref.stroke,
    stroke = _ref$stroke === void 0 ? '4px' : _ref$stroke,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$containerSize = _ref.containerSize,
    containerSize = _ref$containerSize === void 0 ? '65px' : _ref$containerSize;
  return /*#__PURE__*/React.createElement("svg", {
    className: classNames(className, css.spinnerContainer),
    width: containerSize,
    height: containerSize,
    viewBox: "0 0 52 52"
  }, /*#__PURE__*/React.createElement("circle", {
    className: css.path,
    cx: "26px",
    cy: "26px",
    r: "20px",
    fill: "none",
    strokeWidth: stroke
  }));
};
export default Loader;